import { IconBaseProps } from 'react-icons'
import { IoChevronDown } from 'react-icons/io5'

interface AnimatedChevronProps extends IconBaseProps {
    shouldPointUp: boolean
}

/**
 * A chevron icon that smoothly animates between pointing up and down.
 * Built on top of IoChevronDown from react-icons with added rotation animation.
 *
 * @component
 * @example
 * // Simple usage
 * <AnimatedChevron shouldPointUp={isMenuOpen} />
 *
 * // With additional icon props
 * <AnimatedChevron
 *   shouldPointUp={isMenuOpen}
 *   size={24}
 *   color=colors.grays.NOIR
 * />
 */
export const AnimatedChevron = ({
    shouldPointUp,
    ...props
}: AnimatedChevronProps) => {
    return (
        <IoChevronDown
            {...props}
            style={{
                transform: shouldPointUp ? 'rotate(180deg)' : 'rotate(0deg)',
                transition: 'transform 0.2s ease-out',
            }}
        />
    )
}
